// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BusinessIcon from '@mui/icons-material/Business';
import MemoryIcon from '@mui/icons-material/Memory';
// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: icon('ic_user'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  external: icon('ic_external'),
  calendar: icon('ic_calendar'),
};
const navConfig = [
  {
    subheader: 'General',
    items: [
      {
        title: '统计概览',
        path: PATH_DASHBOARD.stats.root,
        icon: ICONS.analytics,
        children: [
          { title: '全局统计', path: PATH_DASHBOARD.stats.global },
          { title: '区域统计', path: PATH_DASHBOARD.stats.regions },
        ],
      },
      {
        title: '工厂管理',
        path: PATH_DASHBOARD.factory.root,
        icon: <AssignmentIcon />,
        children: [
          { title: '设备列表', path: PATH_DASHBOARD.factory.list },
          { title: '接口密钥', path: PATH_DASHBOARD.factory.keys },
        ],
      },
      {
        title: '租户管理',
        path: PATH_DASHBOARD.tenants.root,
        icon: <BusinessIcon />,
        children: [{ title: '租户列表', path: PATH_DASHBOARD.tenants.list }],
      },
      {
        title: '固件管理',
        path: PATH_DASHBOARD.firmware.root,
        icon: <MemoryIcon />,
        children: [
          { title: '机型与发布', path: PATH_DASHBOARD.firmware.targets },
          { title: '固件版本', path: PATH_DASHBOARD.firmware.releases },
          { title: '发布密钥', path: PATH_DASHBOARD.firmware.keys },
        ],
      },
    ],
  },
];

export default navConfig;
